var React = require('react');

function Shop8 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"shop-8"),React.createElement("path",{"d":"M13.415 215.245l474.010-171.623c9.523-3.379 19.968 1.434 23.45 10.957 1.741 4.403 1.434 9.216-0.409 13.312l-150.631 389.939c-3.481 9.318-14.029 14.029-23.552 10.547-1.536-0.819-2.969-1.536-4.403-2.56-189.235-128.103-103.526-70.041-322.355-218.317-8.294-5.734-10.547-16.999-4.813-25.395 2.253-3.379 5.325-5.53 8.704-6.861v0 0zM179.609 318.771v0l254.157-216.883-374.067 135.475 119.911 81.408zM453.735 113.561v0l-255.078 217.703 135.68 92.058 119.399-309.76z","key":1})]);
}

Shop8.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = Shop8;

Shop8.default = Shop8;
